/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-color-shades-generator block)");
/* eslint-enable no-console */
(function () {
    'use strict';
    let baseHex = '#6366f1', count = 10, mode = 'hsl', viewMode = 'grid', fmtMode = 'css', contrastColor = '#ffffff';
    const PRESETS = ['#ef4444', '#f97316', '#eab308', '#22c55e', '#14b8a6', '#6366f1', '#8b5cf6', '#ec4899', '#06b6d4', '#3b82f6', '#000000', '#6b7280', '#a3a3a3', '#dc2626', '#d97706', '#16a34a', '#0891b2', '#4f46e5', '#7c3aed', '#db2777'];
    const $ = id => document.getElementById(id);
    const colorPicker = $('colorPicker'), hexInput = $('hexInput'), shadesCount = $('shadesCount'), shadesMode = $('shadesMode');
    const shadesGrid = $('shadesGrid'), shadesList = $('shadesList'), tailwindGrid = $('tailwindGrid');
    const codeOutput = $('codeOutput'), btnCopy = $('btnCopy'), btnRandom = $('btnRandom');
    const presetsGrid = $('presetsGrid'), contrastColorPicker = $('contrastColor'), contrastHexInput = $('contrastHex');
    const contrastGridEl = $('contrastGrid'), toast = $('toast');
    // Constantes de défaut
    const DEFAULT_HEX = '#6366f1';
    const DEFAULT_COUNT = 10;
    const DEFAULT_MODE = 'hsl';
    // Fonction reset
    function resetAll() {
        count = DEFAULT_COUNT;
        mode = DEFAULT_MODE;
        shadesCount.value = DEFAULT_COUNT;
        shadesMode.value = DEFAULT_MODE;
        setColor(DEFAULT_HEX);
        render();
    }
    // Bouton Reset
    document.getElementById('btnReset').addEventListener('click', resetAll);

    // Forcer le reset au chargement (évite la restauration du cache navigateur)
    window.addEventListener('DOMContentLoaded', () => {
        resetAll();
    });
    function hexToRgb(hex) { const h = hex.replace('#', ''); const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
    function rgbToHex(r, g, b) { return '#' + [r, g, b].map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join(''); }
    function rgbToHsl(r, g, b) { r /= 255; g /= 255; b /= 255; const mx = Math.max(r, g, b), mn = Math.min(r, g, b); let h, s, l = (mx + mn) / 2; if (mx === mn) { h = s = 0; } else { const d = mx - mn; s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn); switch (mx) { case r: h = (g - b) / d + (g < b ? 6 : 0); break; case g: h = (b - r) / d + 2; break; default: h = (r - g) / d + 4; }h /= 6; } return [h * 360, s * 100, l * 100]; }
    function hslToRgb(h, s, l) { h /= 360; s /= 100; l /= 100; if (s === 0) { const v = Math.round(l * 255); return [v, v, v]; } const q = l < .5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q; const hue2rgb = (p, q, t) => { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < 1 / 2) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p; }; return [Math.round(hue2rgb(p, q, h + 1 / 3) * 255), Math.round(hue2rgb(p, q, h) * 255), Math.round(hue2rgb(p, q, h - 1 / 3) * 255)]; }
    function luminance(r, g, b) { const c = [r, g, b].map(v => { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }); return .2126 * c[0] + .7152 * c[1] + .0722 * c[2]; }
    function contrast(hex1, hex2) { const [r1, g1, b1] = hexToRgb(hex1), [r2, g2, b2] = hexToRgb(hex2); const l1 = luminance(r1, g1, b1), l2 = luminance(r2, g2, b2); const li = Math.max(l1, l2), da = Math.min(l1, l2); return (li + .05) / (da + .05); }
    function contrastLabel(r) { if (r >= 7) return { text: 'AAA', color: '#166534' }; if (r >= 4.5) return { text: 'AA', color: '#1a7a3a' }; if (r >= 3) return { text: 'AA Large', color: '#854d0e' }; return { text: 'Fail', color: '#c00' }; }

    function generateShades(hex, n, m) {
        const [r, g, b] = hexToRgb(hex); const [h, s, l] = rgbToHsl(r, g, b);
        const mid = Math.floor(n / 2);
        return Array.from({ length: n }, (_, i) => {
            let nl, ns;
            if (m === 'hsl') {
                if (i < mid) { const t = i / mid; nl = 5 + (l - 5) * t; ns = Math.max(0, s * (.6 + .4 * t)); }
                else if (i === mid) { nl = l; ns = s; }
                else { const t = (i - mid) / (n - 1 - mid); nl = l + (95 - l) * t; ns = Math.max(0, s * (1 - .4 * t)); }
                const [nr, ng, nb] = hslToRgb(h, ns, nl); return rgbToHex(nr, ng, nb);
            } else if (m === 'lum') {
                if (i < mid) { const t = i / mid; nl = 5 + (l - 5) * t; }
                else if (i === mid) { nl = l; }
                else { const t = (i - mid) / (n - 1 - mid); nl = l + (95 - l) * t; }
                const [nr, ng, nb] = hslToRgb(h, s, nl); return rgbToHex(nr, ng, nb);
            } else {
                if (i < mid) { const t = i / mid; return rgbToHex(Math.round(r * t), Math.round(g * t), Math.round(b * t)); }
                else if (i === mid) { return rgbToHex(r, g, b); }
                else { const t = (i - mid) / (n - 1 - mid); return rgbToHex(Math.round(r + (255 - r) * t), Math.round(g + (255 - g) * t), Math.round(b + (255 - b) * t)); }
            }
        });
    }

    function generateTailwindShades(hex) {
        const STEPS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
        const [r, g, b] = hexToRgb(hex); const [h, s] = rgbToHsl(r, g, b);
        return STEPS.map(step => {
            const t = 1 - (step / 1000); const nl = t * 90 + 5;
            const ns = Math.max(0, s * (step === 500 ? 1 : step < 500 ? .92 : .88));
            const [nr, ng, nb] = hslToRgb(h, ns, nl);
            return { step, color: rgbToHex(nr, ng, nb) };
        });
    }

    function getLabel(i, total) { const mid = Math.floor(total / 2); if (i === mid) return { text: 'Base', isBase: true }; if (i === 0) return { text: 'Darkest', isBase: false }; if (i === total - 1) return { text: 'Lightest', isBase: false }; return { text: Math.round((i / (total - 1)) * 100) + '%', isBase: false }; }

    function render() {
        const shades = generateShades(baseHex, count, mode);
        shadesGrid.innerHTML = '';
        shades.forEach((hex, i) => {
            const el = document.createElement('div'); el.className = 'shade-item';
            const { text: gl, isBase: gb } = getLabel(i, count);
            el.innerHTML = `<div class="shade-color" style="background:${hex}"></div><div class="shade-label${gb ? ' is-base' : ''}">${hex.toUpperCase()}<br><span class="shade-name">${gl}</span></div>`;
            el.addEventListener('click', () => copyHex(hex.toUpperCase())); shadesGrid.appendChild(el);
        });
        shadesList.innerHTML = '';
        shades.forEach((hex, i) => {
            const [r, g, b] = hexToRgb(hex);
            const el = document.createElement('div'); el.className = 'shade-row';
            const { text: ll, isBase: lb } = getLabel(i, count);
            el.innerHTML = `<div class="shade-row-color" style="background:${hex}"></div><div class="shade-row-hex">${hex.toUpperCase()}</div><div class="shade-row-rgb">rgb(${r}, ${g}, ${b})</div><div class="shade-row-pct" style="${lb ? 'color:#000;font-weight:700;' : ''}">${ll}</div><div class="copied-badge" id="cb${i}">Copied!</div>`;
            el.addEventListener('click', () => { copyHex(hex.toUpperCase()); const b = document.getElementById('cb' + i); b.classList.add('show'); setTimeout(() => b.classList.remove('show'), 1200); });
            shadesList.appendChild(el);
        });
        const tw = generateTailwindShades(baseHex);
        tailwindGrid.innerHTML = '';
        tw.forEach(({ step, color }) => {
            const el = document.createElement('div'); el.className = 'shade-item';
            el.innerHTML = `<div class="shade-color" style="background:${color}"></div><div class="shade-label">${color.toUpperCase()}<br><span class="shade-name">${step}</span></div>`;
            el.addEventListener('click', () => copyHex(color.toUpperCase())); tailwindGrid.appendChild(el);
        });
        renderCode(shades); renderContrast(shades);
    }

    function renderCode(shades) {
        if (fmtMode === 'css') { codeOutput.value = ':root {\n' + shades.map((h, i) => `  --color-shade-${i + 1}: ${h};`).join('\n') + '\n}'; }
        else if (fmtMode === 'scss') { codeOutput.value = shades.map((h, i) => `$shade-${i + 1}: ${h};`).join('\n'); }
        else if (fmtMode === 'json') { const o = {}; shades.forEach((h, i) => o['shade-' + (i + 1)] = h); codeOutput.value = JSON.stringify(o, null, 2); }
        else { codeOutput.value = 'const shades = [\n' + shades.map(h => `  "${h}"`).join(',\n') + '\n];'; }
    }

    function renderContrast(shades) {
        contrastGridEl.innerHTML = '';
        shades.forEach(hex => {
            const ratio = contrast(hex, contrastColor);
            const r = ratio.toFixed(1); const { text, color } = contrastLabel(ratio);
            const el = document.createElement('div'); el.className = 'shade-item'; el.style.cursor = 'default';
            el.innerHTML = `<div class="shade-color" style="background:${hex};display:flex;align-items:center;justify-content:center;"><span style="color:${contrastColor};font-size:13px;font-weight:700;">Aa</span></div><div class="shade-label" style="font-size:9px;line-height:1.6;">${r}:1<br><span style="color:${color};font-weight:700;">${text}</span></div>`;
            contrastGridEl.appendChild(el);
        });
    }

    function buildPresets() {
        presetsGrid.innerHTML = '';
        PRESETS.forEach(hex => {
            const el = document.createElement('div'); el.className = 'palette-dot'; el.style.background = hex; el.title = hex;
            el.addEventListener('click', () => { setColor(hex); render(); }); presetsGrid.appendChild(el);
        });
    }

    function showToast(msg) { toast.textContent = msg; toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 1800); }
    function copyHex(text) { navigator.clipboard.writeText(text).then(() => showToast('Copied: ' + text)).catch(() => { const ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); showToast('Copied: ' + text); }); }
    function setColor(hex) { baseHex = hex; colorPicker.value = hex; hexInput.value = hex.replace('#', '').toUpperCase(); hexInput.classList.remove('invalid'); }

    colorPicker.addEventListener('input', () => { setColor(colorPicker.value); render(); });
    hexInput.addEventListener('input', () => {
        const v = hexInput.value.trim().replace('#', '');
        if (/^[0-9a-fA-F]{6}$/.test(v)) { hexInput.classList.remove('invalid'); baseHex = '#' + v; colorPicker.value = baseHex; render(); }
        else hexInput.classList.add('invalid');
    });
    shadesCount.addEventListener('change', () => { count = Math.max(3, Math.min(50, parseInt(shadesCount.value) || 10)); shadesCount.value = count; render(); });
    shadesMode.addEventListener('change', () => { mode = shadesMode.value; render(); });
    btnRandom.addEventListener('click', () => { const rand = Math.floor(Math.random() * 0xffffff); const r = '#' + rand.toString(16).padStart(6, '0'); setColor(r); render(); });
    document.getElementById('viewTabs').querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.getElementById('viewTabs').querySelectorAll('button').forEach(b => b.classList.remove('active')); btn.classList.add('active'); viewMode = btn.dataset.view;
            $('gridView').classList.toggle('hidden', viewMode !== 'grid'); $('listView').classList.toggle('hidden', viewMode !== 'list'); $('tailwindView').classList.toggle('hidden', viewMode !== 'tailwind');
        });
    });
    document.getElementById('fmtTabs').querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.getElementById('fmtTabs').querySelectorAll('button').forEach(b => b.classList.remove('active')); btn.classList.add('active'); fmtMode = btn.dataset.fmt;
            renderCode(generateShades(baseHex, count, mode));
        });
    });
    btnCopy.addEventListener('click', () => { copyHex(codeOutput.value); btnCopy.textContent = '✓'; btnCopy.classList.add('ok'); setTimeout(() => { btnCopy.textContent = 'Copy'; btnCopy.classList.remove('ok'); }, 1500); });
    contrastColorPicker.addEventListener('input', () => { contrastColor = contrastColorPicker.value; contrastHexInput.value = contrastColor.replace('#', '').toUpperCase(); renderContrast(generateShades(baseHex, count, mode)); });
    contrastHexInput.addEventListener('input', () => { const v = contrastHexInput.value.trim().replace('#', ''); if (/^[0-9a-fA-F]{6}$/.test(v)) { contrastColor = '#' + v; contrastColorPicker.value = contrastColor; renderContrast(generateShades(baseHex, count, mode)); } });

    buildPresets();
    resetAll(); // à la place de render()
})();